import {Base} from "@/api/Base"

export class ReportDelete extends Base {
    path = "report/delete"
}